import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Access = {
    type: string;
    booking?: {
        id: string | number;
    };
    bonoUser?: {
        id: string | number;
    };
    groupMember?: {
        group?: {
            id: string | number;
        };
    };
    student?: {
        id: string | number;
    };
    boleto?: {
        id: string | number;
    };
};

type AccessItem = {
    type: string;
    id?: string | number;
    name?: string;
};

type Props = {
    access: Access;
    onClick?: (item: AccessItem) => void;
};

export function SttChipAccessType({
    access,
    onClick,
}: Props): React.ReactElement | null {
    const { t } = useTranslation();

    if (!access) {
        return null;
    }

    let item: AccessItem = {
        type: access.type,
    };

    if (access.booking) {
        item = {
            ...item,
            id: access.booking?.id,
            name: t('labels.booking'),
        };
    } else if (access.bonoUser) {
        /* Creo que esto no sirve para nada ya que siempre habrá un booking si hay un bonoUser */
        item = {
            ...item,
            id: access.bonoUser?.id,
            name: t('labels.bono'),
        };
    } else if (access.groupMember) {
        item = {
            ...item,
            id: access.groupMember?.group?.id,
            name: t('labels.abono'),
        };
    } else if (access.student) {
        item = {
            ...item,
            id: access.student?.id,
            name: t('labels.class'),
        };
    } else if (access.boleto) {
        item = {
            ...item,
            id: access.boleto?.id,
            name: t('labels.bono'),
        };
    } else {
        return null;
    }

    return (
        <Tooltip arrow placement="top" title={item.id || ''}>
            <Chip
                clickable
                size="small"
                label={item?.name}
                onClick={() => {
                    if (onClick) {
                        onClick(item);
                    }
                }}
            />
        </Tooltip>
    );
}
